export class Dyn {
    public static SHIP_FACTOR: number = 1.0;
    public static SHIP_FLATRATE: number = 25;
    public static CURRSIGN: string = '€';
    public static COUNTRY_ISO: string = 'DE';
    public static SHIP_MINVAL: number = 5000;
    public static SHIP_LIFT: number = 100;
    public static IR_HP_DEL_LEN: number = 200;
    public static HP_PR_CO_FA: number = 0.005;
    public static MERGE_LIMIT: number = 10;
}